import React, { useState, useEffect } from "react";
import { motion, useMotionValue, useSpring, animate } from "framer-motion";

interface AnimatedNumberProps {
  value: number;
  duration?: number;
}

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({
  value,
  duration = 2,
}) => {
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, { stiffness: 100, damping: 20 });
  const [current, setCurrent] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (started) {
      motionValue.set(0);
      const controls = animate(motionValue, value, { duration });
      return controls.stop;
    }
  }, [started, value, duration, motionValue]);

  useEffect(() => {
    const unsubscribe = springValue.on("change", (latest) => {
      setCurrent(Math.round(latest));
    });
    return () => unsubscribe();
  }, [springValue]);

  return (
    <motion.span
      onViewportEnter={() => {
        if (!started) setStarted(true);
      }}
    >
      {current}
    </motion.span>
  );
};

export default AnimatedNumber;
